const readImageDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Unable to read selected file.'));
    reader.readAsDataURL(file);
  });

const loadImageElement = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Unable to process selected image.'));
    img.src = src;
  });

const canvasToBlob = (canvas, type, quality) =>
  new Promise((resolve) => {
    canvas.toBlob(resolve, type, quality);
  });

export const compressImageToTargetKB = async (file, targetKB = 50) => {
  if (!file?.type?.startsWith('image/')) {
    throw new Error('Please upload an image file for transfer proof.');
  }

  const targetBytes = targetKB * 1024;
  const imageDataUrl = await readImageDataUrl(file);
  const imageElement = await loadImageElement(imageDataUrl);

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  const maxDimensions = [1280, 1080, 900, 768, 640, 512];
  const qualities = [0.82, 0.72, 0.62, 0.52, 0.45, 0.38, 0.32];

  let bestBlob = null;

  for (const maxDimension of maxDimensions) {
    const scale = Math.min(1, maxDimension / Math.max(imageElement.width, imageElement.height));
    canvas.width = Math.max(1, Math.floor(imageElement.width * scale));
    canvas.height = Math.max(1, Math.floor(imageElement.height * scale));

    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(imageElement, 0, 0, canvas.width, canvas.height);

    for (const quality of qualities) {
      const candidate = await canvasToBlob(canvas, 'image/jpeg', quality);

      if (!candidate) {
        continue;
      }

      if (!bestBlob || candidate.size < bestBlob.size) {
        bestBlob = candidate;
      }

      if (candidate.size <= targetBytes) {
        return new File([candidate], `${file.name.replace(/\.[^/.]+$/, '') || 'proof'}-optimized.jpg`, {
          type: 'image/jpeg',
        });
      }
    }
  }

  if (!bestBlob) {
    return file;
  }

  return new File([bestBlob], `${file.name.replace(/\.[^/.]+$/, '') || 'proof'}-optimized.jpg`, {
    type: 'image/jpeg',
  });
};
